import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Tuple, Make, Tuple3, EqualiserBar } from '../../entities';
import {
  AvailableActionViewModel,
  ReplaceActionViewModel,
  ActionInInventoryViewModel,
  AvailableSystemToBeAReplacementViewModel,
  ReplacementCompartmentViewModel,
  SystemReplacementWillEffectFutureActionsWarningViewModel,
  ActionsWillEffectedByAction,
  ActionResult,
  SystemReplacementActionViewModel,
  GeneralActionViewModel,
  ComponentOnSystemViewModel,
  ReplaceMultipleComponentsOnSystemViewModel,
  ComponentReplacementWillBeEffectActionsWarningViewModel,
  GetInvaildActionsOnComponents,
  MultipleComponentActionRequest,
  InspectionAction,
  ShoeInformationAdd,
  recordActionService
} from './action-models';
import { ComponentDetails, SystemDetails } from '../manage-equipment/models/manage-equipment.model';

@Injectable()
export class ActionService {
  getVaildationOfComponentReplacement(componentIds: number[], equipmentId: number, actionDate: Date, actionAtEquipmentSMU: number): Observable<ComponentReplacementWillBeEffectActionsWarningViewModel> {
    const request = new GetInvaildActionsOnComponents(componentIds, equipmentId, actionAtEquipmentSMU, actionDate);
    return this._http.post<ComponentReplacementWillBeEffectActionsWarningViewModel>('api/Action/GetComponentReplacementVaildation', request).pipe(catchError(this.handleError));
  }
  GetComponentReplacementBrends(): Observable<Make[] > {
    return this._http.get<Make[] >('api/Action/GetComponentReplacementBrends').pipe(catchError(this.handleError));
  }

  getExtraMakeOfThisEquipment(equipmentId: number): Observable<Make> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get<Make>('api/Action/GetExtraMakeInformatOfThisEquipment', options).pipe(catchError(this.handleError));
  }


  getComponentsOnThisSystem(systemId): Observable<ComponentOnSystemViewModel[]> {
    const options = {
      params: new HttpParams().set('systemId', systemId.toString())
    };
    return this._http.get<ComponentOnSystemViewModel[]>('api/Action/GetComponentsOnThisSystem', options).pipe(catchError(this.handleError));
  }

  constructor(private _http: HttpClient) {}
  public GetAvailaleActionsForComponent(compartId, equipmentId: number): Observable<AvailableActionViewModel[]> {
    const options = {
      params: new HttpParams().set('compartId', compartId.toString()).set('EquipmentId', equipmentId.toString())
    };
    return this._http.get<AvailableActionViewModel[]>('api/Action/GetAvailaleActionsForComponent', options).pipe(catchError(this.handleError));
  }

  public getCustomerHourlyRate(customerId: number): Observable<any> {
    const options = {
      params: new HttpParams().set('customerId', customerId.toString())
    };
    return this._http.get('api/Action/GetCustomerHourlyRate', options).pipe(catchError(this.handleError));
  }

  public recordNewAction(model: ReplaceActionViewModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/Action/RecordNormalActions', model).pipe(catchError(this.handleError));
  }
  

  public recordNewInventoryAction(model: GeneralActionViewModel): Observable<Tuple> {
    const rightDate = new Date(model.ActionDate);
    model.ActionDate = rightDate;
    model.StringDate = rightDate.toLocaleDateString('en-US');
    return this._http.post<Tuple>('api/Action/RecordNewInventoryActions', model).pipe(catchError(this.handleError));
  }

  // public recordAction(model: GeneralActionViewModel): Observable<Tuple> {
  //   return this._http.post<Tuple>('api/Action/RecordActions', model).pipe(catchError(this.handleError));
  // }

  // public recordAction(model: GeneralActionViewModel): Observable<Tuple> {
  //   return this._http.post('api/Action/RecordActions', model).pipe(catchError(this.handleError));
  // }

  public recordNewReplacementAction(model: ReplaceActionViewModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/Action/RecordReplacementActions', model).pipe(catchError(this.handleError));
  }

  public getReplacementComponentOptions(equnitId: number): Observable<ReplacementCompartmentViewModel[]> {
    const options = {
      params: new HttpParams()
        .set('equnitId', equnitId.toString())
    };
    return this._http.get<ReplacementCompartmentViewModel[]>('api/Action/GetReplacementComponentOptions', options).pipe(catchError(this.handleError));
  }

  public getComponentBudgetLife(oldGeneralEqunitId) {
    const options = {
      params: new HttpParams().set('oldGeneralEqUnitId', oldGeneralEqunitId.toString())
    };
    return this._http.get('api/Action/GetComponentBudgetLife', options).pipe(catchError(this.handleError));
  }



  public GetActionSystemViews(equipmentId: number, systemType: number, side: number) {
    const options = {
      params: new HttpParams()
      .set('equipmentId', equipmentId.toString())
      .set('side', side.toString())
      .set('systemType', systemType.toString())
    };
    return this._http.get('api/Action/GetActionSystemViews', options).pipe(catchError(this.handleError));
  }


  public getSystemViewForDisplay(systemId: number): Observable<AvailableSystemToBeAReplacementViewModel> {
    const options = {
      params: new HttpParams()
      .set('systemId', systemId.toString())
    };
    return this._http.get<AvailableSystemToBeAReplacementViewModel>('api/Action/GetSystemViewForDisplay', options).pipe(catchError(this.handleError));
  }




  public getAvailbleSystemReplacement(equipmentId: number, jobsiteId: number, isChainReplaceAction: boolean, replacingSystemId: number): Observable<AvailableSystemToBeAReplacementViewModel[]> {
    const options = {
      params: new HttpParams()
      .set('equipmentId', equipmentId.toString())
      .set('jobsiteId', jobsiteId.toString())
      .set('isChainReplaceAction', isChainReplaceAction.toString())
      .set('replacingSystemId', replacingSystemId.toString()),
    };
    return this._http.get<AvailableSystemToBeAReplacementViewModel[]>('api/Action/GetAvailbleSystemReplacement', options).pipe(catchError(this.handleError));
}
getFutureActionsForNewSystem(oldSystemId: number, newSystemId: number, equipmentId: number, actionDate: Date, smu: number): Observable<SystemReplacementWillEffectFutureActionsWarningViewModel> {




  const model = new ActionsWillEffectedByAction();
  model.NewSystemId = newSystemId;
  model.OldSystemId = oldSystemId;
  model.EquipmentId = equipmentId;
  model.ActionDate = actionDate;
  model.UninstallAtSMU = smu;
  const rightDate = new Date(actionDate);
  model.ActionDate = rightDate;
  model.StringDate = rightDate.toLocaleDateString('en-US');


  return this._http.post<SystemReplacementWillEffectFutureActionsWarningViewModel>('api/Action/GetNewSystemActionsWarnings', model).pipe(catchError(this.handleError));
}
getFutureActionsForOldSystem(oldSystemId: number, newSystemId: number, equipmentId: number, actionDate: Date, smu: number): Observable<SystemReplacementWillEffectFutureActionsWarningViewModel> {
  const model = new ActionsWillEffectedByAction();
  model.NewSystemId = newSystemId;
  model.OldSystemId = oldSystemId;
  model.EquipmentId = equipmentId;
  model.ActionDate = actionDate;
  model.UninstallAtSMU = smu;


  const rightDate = new Date(actionDate);
  model.ActionDate = rightDate;
  model.StringDate = rightDate.toLocaleDateString('en-US');
  return this._http.post<SystemReplacementWillEffectFutureActionsWarningViewModel>('api/Action/GetFutureInspectionAndActionWarningsToNotifyUser', model).pipe(catchError(this.handleError));
}



getComponentActionView(generalEqUnitId: number): Observable<ComponentDetails> {
  const options = {
    params: new HttpParams()
    .set('generalEqUnitId', generalEqUnitId.toString())
  };
  return this._http.get<ComponentDetails>('api/Action/GetComponentActionView', options).pipe(catchError(this.handleError));
}


public PerformAction(action: GeneralActionViewModel): Observable<ActionResult> {
  const rightDate = new Date(action.ActionDate);
  action.ActionDate = rightDate;
  action.StringDate = rightDate.toLocaleDateString('en-US');
  return this._http.post<ActionResult>('api/Action/PerformAction', action).pipe(catchError(this.handleError));
}

public PerformActionForFlaggedComponent(action: GeneralActionViewModel): Observable<ActionResult> {
  const rightDate = new Date(action.ActionDate);
  action.ActionDate = rightDate;
  action.StringDate = rightDate.toLocaleDateString('en-US');
  return this._http.post<any>('api/Action/PerformActionFlaggedComponent', action).pipe(catchError(this.handleError));
}

public PerformInspectionAction(action: InspectionAction): Observable<Tuple3> {
  const rightDate = new Date(action.Actiondate);
  action.Actiondate = rightDate;
  action.InspectionDate = rightDate.toLocaleDateString('en-US');
  return this._http.post<Tuple3>('api/Inspection/PublishInspectionOnAction', action).pipe(catchError(this.handleError));
}



public SystemReplacement(action, newSystemId , oldSystemId,ActionTypeOnChainOrFrame): Observable<ActionResult> {
  const newParam = new SystemReplacementActionViewModel(action, newSystemId, oldSystemId, ActionTypeOnChainOrFrame);
  return this._http.post<ActionResult>('api/Action/MakeSystemReplacement', newParam).pipe(catchError(this.handleError));
}

  public SystemReplacementAction_SwapComponents(newSystemId, oldSystemId, replaceComponentIDs): Observable<boolean> {
    const newParam = new recordActionService(newSystemId, oldSystemId, replaceComponentIDs);
    return this._http.post<boolean>('api/Action/SystemReplacementAction_SwapComponents', newParam).pipe(catchError(this.handleError));
  }

public MultipleComponentReplacement(request: MultipleComponentActionRequest): Observable<ActionResult> {
  return this._http.post<ActionResult>('api/Action/MultipleComponentsReplacement', request).pipe(catchError(this.handleError));
}


  public GetReplacingMultipleComponentsOnSystemViews(equipmentId: number, systemSide: number): Observable<ReplaceMultipleComponentsOnSystemViewModel[]> {
    const options = {
      params: new HttpParams()
      .set('equipmentId', equipmentId.toString())
      .set('side', systemSide.toString()),
    };
    return this._http.get<ReplaceMultipleComponentsOnSystemViewModel[]>('api/Action/GetReplacingMultipleComponentsOnSystemViews', options).pipe(catchError(this.handleError));
  }

  getFutureInspectionForSelectedEquipment(EquipmentId: number, actionDate: Date, smu: number): Observable<SystemReplacementWillEffectFutureActionsWarningViewModel> {
    const model = new ActionsWillEffectedByAction();
    model.EquipmentId = EquipmentId;
    model.ActionDate = actionDate;
    model.UninstallAtSMU = smu;
    const rightDate = new Date(actionDate);
    model.ActionDate = rightDate;
    model.StringDate = rightDate.toLocaleDateString('en-US');
    return this._http.post<SystemReplacementWillEffectFutureActionsWarningViewModel>('api/Action/GetFutureInspectionForSelectedEquipment', model).pipe(catchError(this.handleError));
  }

  getPreviousInspectionForSelectedEquipment(EquipmentId: number, actionDate: Date, smu: number): Observable<SystemDetails[]> {
    const model = new ActionsWillEffectedByAction();
    model.EquipmentId = EquipmentId;
    model.ActionDate = actionDate;
    model.UninstallAtSMU = smu;
    const rightDate = new Date(actionDate);
    model.ActionDate = rightDate;
    model.StringDate = rightDate.toLocaleDateString('en-US');
    return this._http.post<SystemDetails[]>('api/ManageEquipment/GETPreviousInspectionForSelectedEquipment', model).pipe(catchError(this.handleError));
  }

  CheckValidationForAction(EquipmentId: number,actionDate: Date, smu: number): Observable<any> {
    const model = new ActionsWillEffectedByAction();
    model.EquipmentId = EquipmentId;
    model.ActionDate = actionDate;
    model.UninstallAtSMU = smu;
    const rightDate = new Date(actionDate);
    model.ActionDate = rightDate;
    model.StringDate = rightDate.toLocaleDateString('en-US');
    return this._http.post('api/Action/CheckValidationForAction', model).pipe(catchError(this.handleError));
  }

  createEqualiserBarAction(model: EqualiserBar): Observable<number> {
    return this._http.post<number>('api/Action/CreateEqualiserBarAction', model).pipe(catchError(this.handleError));
  }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error || 'Server error');
  }
}